import axios from "./axiosInstance";


const updateThread = async (threadId: string, newName?: string, deleted?: boolean) => {
    try {
        const response = await axios.put(`threads/update`, {
            thread_id: threadId,
            new_name: newName,
            delete: deleted
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching threads:', error);
        throw error;
    }
}



const getThreads = async (userId: string) => {
    try {
        const response = await axios.get(`threads/user/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching threads:', error);
        throw error;
    }
}

const createThreadApi = async (threadId?: string) => {
    try {
        const response = await axios.post(`threads/new`, threadId ? { thread_id: threadId } : {});
        return response.data;
    } catch (error) {
        console.error('Error fetching threads:', error);
        throw error;
    }
}

const getThreadById = async(threadId: string) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_AUTH_URL}threads/${threadId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching thread:', error);
        throw error;
    }
}

export {
    getThreads,
    getThreadById,
    createThreadApi,
    updateThread
}